export default __webpack_public_path__ + "static/media/keyboard.2fac738d.svg";